import React  , { Component } from 'react'
import { withRouter  , Link } from 'react-router-dom'
import axios from "axios" 
import LazyLoad from 'react-lazyload';
import {  HomeSlider,
          HomeTitle,
          Img,
          ResponsiveYouTubeIframe,
          InstagremSliderItem,
          GallerSideBarItem     } from '../../../Components/UI/UI'

import { asyncgetWeather, getImgUrl , getUrl, geinstagramData, limitText } from '../../../Utility/Utility'
import SimpleSlider from '../../../Components/SimpleSlider/SimpleSlider';

import Popup from "reactjs-popup";
import Menu from '../../../Components/Menu/Menu'
import Footer from '../../../Components/Footer/Footer'

import "../Gallery.css"

class GalleryTA extends Component {

  state = {
   
    telAvivWeather : 0,
    instagramData : [],
    instagramDataMobile:[],
    instagramId: null,
    instagramUserImg: null,
    instagramCaption: null ,
    instagramUserName: null ,
    instagramLikes: null ,
    waterTemp : 0,
    jerusalemWeather : 0,
    open: false , 
    isInstaOpen:false,
    openInstagram: false ,    id : null , 

    ctg : '',
    galleryId:'',
    relatedGalery:[
      {
        title : 'YOUR PHOTOS',
        cityId:'yp'
      },
      {
        title : 'JERUSALEM',
        cityId:'ja'
      },
      {
        title: "NAZARETH",
        cityId: "nazareth"
      },
      {
        title : 'SEA OF GALILEE',
        cityId:'sog'
      },
      {
        title : 'TEL AVIV',
        cityId:'ta'
      },
      {
        title : 'DEAD SEA',
        cityId:'deadsea'
      },
      {
        title : 'EILAT',
        cityId:'eilat'
      },
      {
        title : 'CAESAREA',
        cityId:'caesarea'
      },
      {
        title : 'NEGEV',
        cityId:'negev'
      },
      {
        title : 'GALILEE',
        cityId:'galilee'
      },
      {
        title : 'HAIFA',
        cityId:'haifa'
      },
      {
        title : 'CULINARY',
        cityId:'culinary'
      },
      {
        title : 'MARKETS',
        cityId:'markets'
      },
      {
        title : 'ACRE',
        cityId:'acre'
      },
      {
        title : 'Jordan Valley & Judean Desert',
        cityId:'jordandesert'
      },
      {
        title : 'Church of the Holy Sepulchre',
        cityId:'coths'
      }


      ]
     
  } 


  openModel2 = (id) => {

    window.open('https://www.instagram.com/p/' + id, "_blank");
 
  //   // var url ='https://view.activated.co.il/twocities/de/instagram-api.php?ID=' + id; 
  // var url = getUrl() + 'instagram-api.php?ID=' + id; 

  //   // alert(url);

  //   // var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
  //   axios.get(url , {}).then(res => {
  //     var obj = res.data; 

  //     // var userinfo = obj.graphql.shortcode_media;
  //     var likes    = userinfo.edge_media_preview_like.count;
  //     var username = userinfo.owner.username;
  //     var caption  = userinfo.edge_media_to_caption.edges[0].node.text;
  //     var userProfileImg = userinfo.owner.profile_pic_url;

  //     console.log(username);

  //     this.setState({ 
  //         isInstaOpen: true ,
  //         instagramId: id,
  //         instagramUserImg: userProfileImg,
  //         instagramCaption: caption ,
  //         instagramUserName: username ,
  //         instagramLikes: likes ,
  //     });


    // });


  };


  openModal = (id , ctg) => {
    this.setState({ 
        open: true ,
        ctg : ctg,
        id : id,
    });
  };
  


  closeModal = () => {
    this.setState({ open: false });
  };

  closeModal2 = () => {
    this.setState({ isInstaOpen: false });
  };
   componentWillMount() {
     this.updateDimensions();
  }
  updateDimensions = () =>{
      var w = window,
        d = document,
        documentElement = d.documentElement,
        body = d.getElementsByTagName('body')[0],
        width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
        // height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;

        this.setState({width: width});
        
    
  }
  componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.updateDimensions);
  }
  componentDidMount () {
    let galleryId = 'noGalleryId';
    let videoId   = '';
    let cityName   = '';
    let stopLoopAt   = 32;
    console.log(this.props);
    if ( this.props.match.params.galleryId !== undefined ) {
      galleryId = this.props.match.params.galleryId

      if ( galleryId === 'ja' ) {
        videoId = 'V0Acsw3Hf_M';
        stopLoopAt = 53;
        cityName = 'JERUSALEM';
      } else if ( galleryId === 'nazareth' ) {
        videoId = '1M7N5BcmjFM';
        cityName = 'NAZARETH';
        stopLoopAt = 1;
      } else if ( galleryId === 'sog' ) {
        videoId = 'haG-t3wwuMc';
        cityName = 'SEA OF GALILEE';
        stopLoopAt = 4;
      } else if ( galleryId === 'negev') {
        videoId = 'XxWa_MNm5x8';
        stopLoopAt = 17;
        cityName = 'NEGEV';
      } else if ( galleryId === 'ta' ) {
        videoId = '5nqL-oIC0GA';
        stopLoopAt = 28;
        cityName = 'TEL AVIV';
      }else if ( galleryId === 'deadsea') {
        videoId = 'M627s8TdaB8';
        stopLoopAt = 13;
        cityName = 'DEAD SEA';
      }else if ( galleryId === 'eilat') {
        videoId = 'ZdnNT-GDJv4';
        stopLoopAt = 17;
        cityName = 'EILAT';
      }else if ( galleryId === 'caesarea') {
        videoId = 'eLZ433_S6HI';
        stopLoopAt = 4;
        cityName = 'CAESAREA';
      }else if ( galleryId === 'haifa') {
        videoId = '3ahATaKkhBk';
        stopLoopAt = 6;
        cityName = 'HAIFA';
      }else if ( galleryId === 'culinary') {
        videoId = 'JQD9JpMaw9g';
        stopLoopAt = 13;
        cityName = 'CULINARY';
      }else if ( galleryId === 'galilee') {
        videoId = 'ImobrsxsKl8';
        stopLoopAt = 21;
        cityName = 'GALILEE';
      }else if ( galleryId === 'markets') {
        videoId = '2CSCe2WC7Ns';
        stopLoopAt = 13;
        cityName = 'MARKETS';
      }else if ( galleryId === 'yp') {
        videoId = 'M627s8TdaB8';
        stopLoopAt = 13;
        cityName = 'YOUR PHOTOS';
      }else if ( galleryId === 'acre') {
        videoId = 'KlXXyToCmCM';
        stopLoopAt = 1;
        cityName = 'ACRE';
      }else if ( galleryId === 'jordandesert') {
        videoId = '';
        stopLoopAt = 6;
        cityName = 'Jordan Valley & Judean Desert';
      }else if ( galleryId === 'coths') {
        videoId = '';
        stopLoopAt = 5;
        cityName = 'Church of the Holy Sepulchre';
      }

    }


     Promise.all([ asyncgetWeather() , geinstagramData() ]).then( response => {
        const weather = response[0];
        const instagramData = response[1];

      
       
        this.setState({
          deadSeaWeather    : weather.deadsea.temperature,
          jerusalemWeather  : weather.jerusalem.temperature,
          telAvivWeather    : weather.telaviv.temperature,
          waterTemp         : weather.telaviv.water_temp,
          instagramData     : instagramData.posts ,
          galleryId: galleryId,
          videoId : videoId,
          cityName : cityName,
          stopLoopAt : stopLoopAt

        })

     });

  }
  
 
   
  render(){
    
    // let count  = 30;
    let gallery = [];
    for (var i = 1; i <= 60; i++) {
      gallery.push({
        id : i
      });
    };


   
    const sliderSettings = {
      dots: false,
      autoplay: true,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: 'linear',
      slidesToShow: 3,
      slidesToScroll: 3,

      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
      
    };

    let singleGalleryImg = '';
    let singleGalleryImgMob = '';
    let galleryHtml = '';
    let galleryHtml2 = '';
    let galleryHtml3 = '';
    let galleryHtml4 = '';
    let galleryHtml5 = '';
    let galleryHtml6 = '';
    let galleryHtml7 = '';
    let galleryHtml8 = '';
    let galleryHtml9 = '';
    let galleryHtml10 = '';
    let stopLoopAt = '';
    let finatlHtmlToRender = '';
    let videoId = '';
    let relatedGaleryHtml = null;
    let cover = <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />;
    let cityName = '';
    let cssClass = '';
    let instagramHtml = null;


    let bigImgPath = "gallery/ta/big/" +this.state.id +".jpg";
    if ( this.state.ctg === 'ja' ) {
      bigImgPath = "gallery/ja/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'nazareth' ) {
      bigImgPath = "gallery/nazareth/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'sog' ) {
      bigImgPath = "gallery/sog/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'deadsea' ) {
      bigImgPath = "gallery/deadsea/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'eilat' ) {
      bigImgPath = "gallery/eilat/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'caesarea' ) {
      bigImgPath = "gallery/caesarea/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'negev' ) {
      bigImgPath = "gallery/negev/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'haifa' ) {
      bigImgPath = "gallery/haifa/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'culinary' ) {
      bigImgPath = "gallery/culinary/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'galilee' ) {
      bigImgPath = "gallery/galilee/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'markets' ) {
      bigImgPath = "gallery/markets/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'acre' ) {
      bigImgPath = "gallery/acre/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'jordandesert' ) {
      bigImgPath = "gallery/jordandesert/big/" +this.state.id +".jpg";
    }else if( this.state.ctg === 'coths' ) {
      bigImgPath = "gallery/coths/big/" +this.state.id +".jpg";
    }  


    

    
    if ( this.props.match.params.galleryId === undefined ) {
          var instagramData = this.state.instagramData; 
          var size = 1;
          // if ( this.state.width < 600 ) {
          //     size = 4;
          // }
          if ( instagramData.length > 0 ) {

            while (instagramData.length > 0) {
                this.state.instagramDataMobile.push(instagramData.splice(0, size));
            }
            
          }

          if ( this.state.instagramDataMobile.length > 0 ) {
            instagramHtml = this.state.instagramDataMobile.map((arr , i)=>{
              return arr.map((o , i) =>  {



                  var imgLink = "instagram/"+o.id+".jpg";
          
                  if ( this.state.width < 600 ) {
                    imgLink = "instagram/Mobile/"+o.id+".jpg";                
                  }
                  return  <div   onClick={ () => {
                                this.openModel2(o.id)
                             }}> <InstagremSliderItem  
                                    title={o.publishBy}
                                    cssClass={'InstagremSliderItem-' + i}
                                    img= {"instagram/"+o.id+".jpg"}
                                    />
                          </div>
                          
              });
            });
            // console.log('instagramHtml2' , instagramHtml2);
            instagramHtml = instagramHtml.map( (o,i) => {
              // console.log(o);
              return <div>{o}</div>;
            });
            
          }

          const currentInstagramLikeUrl = 'https://www.instagram.com/p/'+this.state.instagramId+'/';
          const currentInstagramUrl     = 'https://www.instagram.com/'+this.state.instagramUserName+'/';
          const currentInstagramImgUrl  = "instagram/"+ this.state.instagramId+ ".jpg";

          // alert('currentInstagramImgUrl : ' +currentInstagramImgUrl);
          // alert('currentInstagramUrl : ' +currentInstagramUrl);
          // alert('currentInstagramLikeUrl : ' +currentInstagramLikeUrl);

          galleryHtml = gallery.map( ( o , i )=> {

              console.log(o);
              let cssClass = 'col';
              if (  i % 3 ===  0 ) {
                cssClass += " first ";
              }
              if ( i <= 28 ) {

                 const imgPath =  "gallery/ta/small/" +o.id +".jpg";
                 return <div className={cssClass}  onClick={ () => {
                            this.openModal(o.id , 'ta')
                         }}> 
                          <Img desktopImg={imgPath} />
                        </div>
                
              }
          });

    
          galleryHtml2 = gallery.map( ( o , i )=> {

              let cssClass = 'col';
             if ( i <= 27 ) {

                  const imgPath =  "gallery/ja/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'ja');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
                
              }
            
          })

          galleryHtml3 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 13 ) {
             
             const imgPath = "gallery/deadsea/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'deadsea');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })

          galleryHtml4 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 17 ) {
             
             const imgPath = "gallery/eilat/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'eilat');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml5 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 4 ) {
             
             const imgPath = "gallery/caesarea/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'caesarea');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml6 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 17 ) {
             
             const imgPath = "gallery/negev/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'negev');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml7 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 5 ) {
             
             const imgPath = "gallery/haifa/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'haifa');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })

          galleryHtml8 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 13 ) {
             
             const imgPath = "gallery/culinary/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'culinary');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml9 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 17 ) {
             
             const imgPath = "gallery/galilee/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'galilee');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })
          galleryHtml10 = gallery.map( ( o , i )=> {

            let cssClass = 'col';
            if ( i <= 13 ) {
             
             const imgPath = "gallery/markets/small/" +o.id +".jpg";
             return <div className={cssClass}  onClick={ () => {
                        this.openModal(o.id , 'markets');
                     }}> 
                      <Img desktopImg={imgPath} />
                    </div>
              }
          })

          finatlHtmlToRender =  <section className="post-data">
          
          <div className="container page-Gallery content-container">
          <HomeTitle>
            GALLERY
            </HomeTitle>
              <div className="col col-100 gallery-grid">

              {this.state.relatedGalery.map((o,i)=> <div className="gal-item"><Link to={`/Pages/Gallery/${o.cityId}`}><Img desktopImg={`gallery/ctg/${o.cityId}.jpg`}/><h3>{o.title}</h3></Link></div>)}
          
              
                




                

             </div>
             <div className="clear"></div>

          </div>

          <Popup
            open={this.state.isInstaOpen}
            closeOnDocumentClick
            onClose={this.closeModal2}
          >
            <div className="modal">
              <a className="close" onClick={this.closeModal2} >
                &times;
              </a>
              <div className="userImgInstagram">
                <Img desktopImg={currentInstagramImgUrl} />
              </div>
              <div className="user-info-instagram">
                <a target="_blank" href={currentInstagramUrl}>
                  <div className="userProfileImgWrapper">
                    <img src={this.state.instagramUserImg} />
                  </div>
                  @{this.state.instagramUserName} 
                </a>

                <div className="instagramCaption">
                  <p>
                    {(this.state.instagramCaption != null) ? limitText(this.state.instagramCaption , 130) : ''}
                  </p>
                </div>

              </div>

              <div className="clear"></div>
              <a target="_blank" href={currentInstagramLikeUrl}>
              <div className="like-wrapper">
                <Img desktopImg={"like.png"} />
              </div>
              </a>


            </div>
          </Popup>

        </section>;


        

        <Popup open={this.state.open} closeOnDocumentClick onClose={this.closeModal2} >
            <div className="modal">
              <a className="close" onClick={this.closeModal2} >
                &times;
              </a>
              <div className="userImgInstagram">
                <Img desktopImg={currentInstagramImgUrl} />
              </div>
              <div className="user-info-instagram">
                <a target="_blank" href={currentInstagramUrl}>
                  <div className="userProfileImgWrapper">
                    <img src={this.state.instagramUserImg} />
                  </div>
                  @{this.state.instagramUserName} 
                </a>

                <div className="instagramCaption">
                  <p>
                    {(this.state.instagramCaption != null) ? limitText(this.state.instagramCaption , 130) : ''}
                  </p>
                </div>

              </div>

              <div className="clear"></div>
              <a target="_blank" href={currentInstagramLikeUrl}>
              <div className="like-wrapper">
                <Img desktopImg={"like.png"} />
              </div>
              </a>


            </div>
          </Popup>
        



      } else {
        const galleryId = this.state.galleryId;
       
        let imgToShow = '';
        if ( galleryId === 'ta' ) {
          imgToShow = '1.jpg';
        }else if (  galleryId === 'ja' ) {
          imgToShow = '4.jpg';
        }else if (  galleryId === 'deadsea' ) {
          imgToShow = '6.jpg';
        }else if (  galleryId === 'eilat' ) {
          imgToShow = '1.jpg';
        }


          if (galleryId === 'jordandesert' || galleryId === 'coths' || galleryId === 'ta' || galleryId === 'markets' || galleryId === 'culinary' || galleryId === 'acre' || galleryId === 'deadsea' || galleryId === 'ja'  || galleryId === 'eilat'  || galleryId === 'negev' || galleryId === 'caesarea' || galleryId === 'haifa'  || galleryId === 'galilee' || galleryId === 'nazareth' || galleryId === 'sog'   ){
              cover = <Img desktopImg={ 'gallery/' + '/ctg/Main/' + galleryId + '.jpg'   } mobileImg ={ 'gallery/' + '/ctg/Mobile/' + galleryId + '.jpg'  } />
              bigImgPath = "gallery/"+galleryId+"/big/" +this.state.id +".jpg";
              
              galleryHtml = gallery.map( ( o , i )=> {
                let cssClass = 'col';
               if ( this.state.stopLoopAt % 3 != 0 && i === this.state.stopLoopAt - 1   ) {
                    // cssClass += ' last';
                    cssClass += ' ';
                }
                if ( i <= this.state.stopLoopAt ) {
                 const imgPath = "gallery/"+galleryId+"/small/" +o.id +".jpg";
                 return <div className={cssClass}  onClick={ () => {
                            this.openModal(o.id , galleryId);
                         }}> 
                          <Img desktopImg={imgPath} />
                        </div>
                  }
              });
          } else if ( galleryId === 'yp' ){
                 // console.log("this.props.match.params.galleryId 10_10 :", this.props.match.params.galleryId);

                cover = <Img desktopImg={ 'gallery/ctg/Main/' + galleryId + '.jpg'   } mobileImg ={ 'gallery/' + 'ctg/Mobile/' + galleryId + '.jpg'  } />
                
               
                galleryHtml = this.state.instagramData.map((o , i)=>{

                  // return arr.map((o , i) =>  {
                    
                      var imgLink = "instagram/"+o.id+".jpg";          
                      if ( this.state.width < 600 ) {
                        imgLink = "instagram/Mobile/"+o.id+".jpg";                
                      }
                      console.log('imgLink' , imgLink);
                      return  <div  onClick={ () => {
                                    this.openModel2(o.id)
                                 }}> 
                                    <Img desktopImg={imgLink} />
                              </div>
                              
                  // });
                });
                // console.log('instagramHtml2' , instagramHtml2);
                galleryHtml = galleryHtml.map( (o,i) => {
                  return <div>{o}</div>;
                });
          }



        relatedGaleryHtml = this.state.relatedGalery.map((o,i)=>{
          const link = '/Pages/Gallery/' + o.cityId;
          if ( o.cityId !== galleryId && i < 3 ) {
            return <GallerSideBarItem title={o.title} 
                                      link={link} 
                                      img={'gallery/' + '/ctg/' + o.cityId + '.jpg' } />
          }
        })

        finatlHtmlToRender = <section className="post-data">
          <div className="clear"></div>
          <div className="container content-container">
              <div className="col col-75">
                
                  <div className="container content-container">
                      <div className="col col-100">
                        <div className="inner"> 
                            <HomeTitle>
                              {this.state.cityName}
                            </HomeTitle>
                          {this.state.videoId && <ResponsiveYouTubeIframe vidId={this.state.videoId} />}
                          <div className="clear"></div>
                          <div className="gallery-html-wrapper">
                            {galleryHtml}
                          </div>
                          <div className="clear"></div>
                        </div>
                      </div>
                      <div className="clear"></div>
                  </div>
              </div>
              <div className="col col-25 sidebar">
                <div className="inner">
                  <HomeTitle>
                    GALLERY
                  </HomeTitle>
                  {relatedGaleryHtml}
                  <a class="show_more button" href={ getUrl() + 'Pages/Gallery'}>
                     ALL PHOTOS >>
                  </a>
                </div>
              </div>
              <div className="clear"></div>
            </div>
        </section>


        
      }



    
    
    return(
      <div className={"page align-center page-Gallery inner-post gallery-" + this.state.galleryId}>
        <Menu />
          {cover}
          {finatlHtmlToRender}
        <Popup
            open={this.state.open}
            closeOnDocumentClick
            onClose={this.closeModal}
          >
            <div className="modal">
              <a className="close" onClick={this.closeModal}>
                &times;
              </a>
              <Img desktopImg={bigImgPath} /> 
            </div>
          </Popup>
        <Footer />
      </div>
    )
  }

}



export default withRouter(GalleryTA)


// WEBPACK FOOTER //
// ./src/Pages/Gallery/TA/Gallery.js